export default __webpack_public_path__ + "static/media/pageBackground.ba5f3716.svg";